class MenuDrawerPanels {
  constructor(drawer) {
    this.drawer = drawer;
    this.isTransitioning = false;
    this.onPanelToggle = this.onPanelToggle.bind(this);
    this.boundMenuDrawer = null;
    this.bindMenuDrawer();
  }

  get menuDrawer() {
    return (
      document.getElementById("menu-drawer") ||
      this.drawer.querySelector("#menu-drawer")
    );
  }

  bindMenuDrawer() {
    const menuDrawer = this.menuDrawer;
    if (!menuDrawer || menuDrawer === this.boundMenuDrawer) return;

    this.boundMenuDrawer?.removeEventListener("click", this.onPanelToggle);
    menuDrawer.addEventListener("click", this.onPanelToggle);
    this.boundMenuDrawer = menuDrawer;
  }

  onPanelToggle(event) {
    const toggle = event.target.closest("[data-panel-toggle]");
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();
    this.switchTo(toggle.getAttribute("aria-controls"));
  }

  switchTo(panelId) {
    if (!panelId || this.isTransitioning) return;

    const menuDrawer = this.menuDrawer;
    if (!menuDrawer) return;

    const toPanel = menuDrawer.querySelector(`#${panelId}`);
    const fromPanel = menuDrawer.querySelector(".menu-drawer__panel.is-visible");

    if (!toPanel || fromPanel === toPanel) return;

    this.isTransitioning = true;

    if (fromPanel) {
      fromPanel.classList.add("is-leaving");
      fromPanel.classList.remove("is-visible");
    }

    toPanel.classList.add("is-visible", "is-entering");

    window.setTimeout(() => {
      fromPanel?.classList.remove("is-leaving");
      if (fromPanel) {
        fromPanel.style.transform = "";
        fromPanel.style.background = "";
      }
      toPanel.classList.remove("is-entering");
      toPanel.style.transform = "";
      this.isTransitioning = false;
    }, 400);
  }

  resetToMain() {
    const menuDrawer = this.menuDrawer;
    if (!menuDrawer) return;

    menuDrawer.querySelectorAll(".menu-drawer__panel").forEach((panel) => {
      panel.classList.remove("is-visible", "is-leaving", "is-entering");
      panel.style.transform = "";
      panel.style.background = "";
    });

    menuDrawer
      .querySelector("[data-main-panel]")
      ?.classList.add("is-visible");
  }

  updateOffset() {
    const header = document.querySelector(".shopify-section-header");
    const menuDrawer = this.menuDrawer;
    if (!header || !menuDrawer) return;

    const offsetTop = Math.max(header.getBoundingClientRect().bottom, 0);
    const offsetValue = `${offsetTop}px`;
    menuDrawer.style.setProperty("--menu-drawer-offset-top", offsetValue);
    this.drawer.style.setProperty("--menu-drawer-offset-top", offsetValue);
  }

  portalMenuDrawer() {
    const menuDrawer = this.drawer.querySelector("#menu-drawer");
    if (!menuDrawer || menuDrawer.dataset.portaled === "true") return;

    this.placeholder = document.createComment("menu-drawer-placeholder");
    menuDrawer.parentNode.insertBefore(this.placeholder, menuDrawer);
    document.body.appendChild(menuDrawer);
    menuDrawer.dataset.portaled = "true";
    menuDrawer.classList.add("menu-drawer--portaled");
    this.bindMenuDrawer();
    this.updateOffset();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        menuDrawer.classList.add("menu-drawer--open");
      });
    });
  }

  closeMenuDrawerAnimation() {
    this.menuDrawer?.classList.remove("menu-drawer--open");
  }

  restoreMenuDrawer() {
    const menuDrawer = this.menuDrawer;
    if (!menuDrawer || menuDrawer.dataset.portaled !== "true") return;

    menuDrawer.classList.remove("menu-drawer--open");

    this.placeholder?.parentNode?.insertBefore(menuDrawer, this.placeholder);
    this.placeholder?.remove();
    this.placeholder = null;
    menuDrawer.dataset.portaled = "false";
    menuDrawer.classList.remove("menu-drawer--portaled");
    menuDrawer.style.removeProperty("--menu-drawer-offset-top");
    this.drawer.style.removeProperty("--menu-drawer-offset-top");
    this.bindMenuDrawer();
  }
}

function initHeaderDrawerPanels() {
  document.querySelectorAll("header-drawer").forEach((drawer) => {
    if (!drawer._panelManager) {
      drawer._panelManager = new MenuDrawerPanels(drawer);
    } else {
      drawer._panelManager.bindMenuDrawer();
    }

    const details = drawer.querySelector("details");
    if (!details || details.dataset.panelToggleBound === "true") return;

    details.dataset.panelToggleBound = "true";
    details.addEventListener("toggle", () => {
      if (details.open) {
        drawer._panelManager.bindMenuDrawer();
        drawer._panelManager.updateOffset();
      } else {
        drawer._panelManager.resetToMain();
        drawer._panelManager.restoreMenuDrawer();
      }
    });
  });
}

function updateOpenMenuDrawerOffset() {
  document.querySelectorAll("header-drawer").forEach((drawer) => {
    const details = drawer.querySelector("details");
    if (details?.open) {
      drawer._panelManager?.updateOffset();
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeaderDrawerPanels);
} else {
  initHeaderDrawerPanels();
}

document.addEventListener("shopify:section:load", initHeaderDrawerPanels);
window.addEventListener("scroll", updateOpenMenuDrawerOffset, { passive: true });
window.addEventListener("resize", updateOpenMenuDrawerOffset, { passive: true });
